var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _g, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrdHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: var(--input-text-color);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: red;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: var(--primary-color);\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1445.32,1295.19v-23.35c-40.84-6.47-72.16-41.92-72.16-84.54v-224.55h-162.38v.07h-27.21v176.38c0,47.19-38.39,85.58-85.58,85.58s-85.6-38.39-85.6-85.58v-459.54h-80.63c-7.98,0-15.71-1.1-23.04-3.16,2.3,5.42,4.24,11.04,5.8,16.81,43.01,4.48,76.64,40.94,76.64,85.11s-31.32,78.07-72.15,84.54v23.35c40.83,6.46,72.15,41.91,72.15,84.53s-33.64,80.64-76.64,85.13c-12.08,44.77-47.41,80.09-92.18,92.17-4.49,43.01-40.95,76.64-85.12,76.64s-78.08-31.32-84.55-72.15h-23.33c-6.47,40.83-41.91,72.15-84.54,72.15s-80.64-33.63-85.13-76.64c-44.77-12.08-80.1-47.4-92.18-92.17-43-4.49-76.64-40.96-76.64-85.13s31.32-78.07,72.15-84.53v-23.35c-40.83-6.47-72.15-41.92-72.15-84.54s33.63-80.63,76.64-85.11c12.08-44.78,47.41-80.11,92.18-92.19,4.49-43.01,40.96-76.65,85.13-76.65s78.07,31.32,84.54,72.16h23.33c6.47-40.84,41.92-72.16,84.55-72.16s80.63,33.64,85.12,76.65c8.99,2.43,17.61,5.79,25.73,9.99-1.09-5.43-1.66-11.04-1.66-16.79v-94.09H271.22c-2.5,0-4.62,2.11-4.62,4.61v1268.72c0,2.5,2.12,4.6,4.62,4.6h1169.5c2.49,0,4.6-2.1,4.6-4.6v-20.69c-40.84-6.47-72.16-41.92-72.16-84.54v-288.62c0-42.62,31.32-78.06,72.16-84.52ZM905.57,1753.92H376.44c-47.19,0-85.59-38.39-85.59-85.59s38.4-85.58,85.59-85.58h529.13c47.19,0,85.59,38.39,85.59,85.58s-38.4,85.59-85.59,85.59ZM1194.19,1753.92h-96.2c-47.2,0-85.6-38.39-85.6-85.59s38.4-85.58,85.6-85.58h96.2c47.19,0,85.59,38.39,85.59,85.58s-38.4,85.59-85.59,85.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  }))), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 534.18,
    y: 767.81,
    width: 213.65,
    height: 213.65
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1630.12,1216.89c16.32,0,29.59-13.27,29.59-29.59v-288.62c0-16.31-13.27-29.59-29.59-29.59h-60.88c-.25,4.59-.82,9.15-1.71,13.62-3.41,17.33-11.25,32.88-22.21,45.56h55.21v229.44h-112.19v-196.59c-4.34.82-8.77,1.35-13.27,1.57-1.66.09-3.33.13-5.01.13h-40.9v224.48c0,16.32,13.28,29.59,29.6,29.59h42.56v133.24h-42.56c-16.32,0-29.6,13.27-29.6,29.58v288.62c0,16.31,13.28,29.59,29.6,29.59h42.56v75.64c0,33.41-27.18,60.6-60.6,60.6H271.22c-33.43,0-60.62-27.19-60.62-60.6V504.84c0-33.42,27.19-60.61,60.62-60.61h561.19v-59.17H271.22c-66.05,0-119.79,53.74-119.79,119.78v1268.72c0,66.04,53.74,119.77,119.79,119.77h1169.5c66.04,0,119.78-53.73,119.78-119.77v-75.64h69.62c16.32,0,29.59-13.28,29.59-29.59v-288.62c0-16.31-13.27-29.58-29.59-29.58h-69.62v-133.24h69.62ZM1600.53,1409.3v229.45h-112.19v-229.45h112.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M905.57,941.25h-42.56v-133.24h42.56c16.32,0,29.59-13.28,29.59-29.59s-13.27-29.58-29.59-29.58h-42.56v-21.52c0-41.18-33.51-74.69-74.69-74.69h-21.52v-42.56c0-16.32-13.27-29.6-29.58-29.6s-29.6,13.28-29.6,29.6v42.56h-133.23v-42.56c0-16.32-13.27-29.6-29.59-29.6s-29.59,13.28-29.59,29.6v42.56h-21.52c-41.18,0-74.69,33.51-74.69,74.69v21.52h-42.56c-16.32,0-29.59,13.27-29.59,29.58s13.27,29.59,29.59,29.59h42.56v133.24h-42.56c-16.32,0-29.59,13.27-29.59,29.59s13.27,29.59,29.59,29.59h42.56v21.52c0,41.18,33.51,74.68,74.69,74.68h21.52v42.57c0,16.31,13.28,29.58,29.59,29.58s29.59-13.27,29.59-29.58v-42.57h133.23v42.57c0,16.31,13.27,29.58,29.6,29.58s29.58-13.27,29.58-29.58v-42.57h21.52c41.18,0,74.69-33.5,74.69-74.68v-21.52h42.56c16.32,0,29.59-13.28,29.59-29.59s-13.27-29.59-29.59-29.59ZM803.83,1037.46h-325.65v-325.65h325.65v325.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.16,1668.33c0,16.31-13.27,29.59-29.59,29.59H376.44c-16.32,0-29.59-13.28-29.59-29.59s13.27-29.58,29.59-29.58h529.13c16.32,0,29.59,13.26,29.59,29.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1223.78,1668.33c0,16.31-13.27,29.59-29.59,29.59h-96.2c-16.32,0-29.6-13.28-29.6-29.59s13.28-29.58,29.6-29.58h96.2c16.32,0,29.59,13.26,29.59,29.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1101.56,863.47c0,25.77,9.86,49.28,26.01,66.95v208.78c0,16.31-13.27,29.58-29.58,29.58s-29.6-13.27-29.6-29.58v-445.54h33.17v169.81Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1475.07,962.69v.13h-5.01c1.68,0,3.35-.04,5.01-.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1768.57,325.16v269.16c0,16.18-13.17,29.34-29.35,29.34h-239.81v239.81c0,1.92-.18,3.8-.54,5.62-2.63,13.51-14.55,23.73-28.81,23.73h-269.15c-16.18,0-29.35-13.17-29.35-29.35v-239.81h-239.8c-16.18,0-29.35-13.16-29.35-29.34v-269.16c0-16.18,13.17-29.35,29.35-29.35h239.8V56.01c0-16.18,13.17-29.35,29.35-29.35h269.15c16.19,0,29.35,13.17,29.35,29.35v239.8h239.81c16.18,0,29.35,13.17,29.35,29.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrdHealth);
export default __webpack_public_path__ + "static/media/brd_health.9ace636518e14b51a68441e704ed81b8.svg";
export { ForwardRef as ReactComponent };